import type { FaireProductEntity } from "../../entity_types/product";

export const p_yw93t3q98r: FaireProductEntity = {
  token: "p_yw93t3q98r",
  type: "product",
  name: "Bat Trellis Halloween Sweater - Mommy and Me",
  brandToken: "b_gro99lye",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/6531e0dcd8a5b9f07e0d8dea428201f308d20cf0810c7640ab24cb9bbe81d979.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6c25f31d1bbd0f8ef5cfced1cd5b4272d5e2213fc4b431c440ae93301f7171ce.jpeg",
    "https://cdn.faire.com/fastly/f781df8f722bf3f2ec49545389352635e105457e251ad22986da424db74fb061.jpeg",
    "https://cdn.faire.com/fastly/500eb29a813ca14f0bdf3a2f503fe286f34dcce362780b8e8751d9d8f95a5ebf.jpeg",
    "https://cdn.faire.com/fastly/796319b79eaa5ce30c5b828f18daa9c1d4ae8ff0457f4b5422ffb966a1799615.jpeg",
    "https://cdn.faire.com/fastly/6dc7521b8cdf9c920c0e2f505e42a9af60a50023f16fe2a4219d751203516e34.jpeg",
    "https://cdn.faire.com/fastly/4d5fa3c52b632bff0a587c4c5496209bc99ee7c3cfaeea0a122982b26f3b3cdc.jpeg",
  ],
  priceDollars: 32,
  description:
    "Sweet bows and fluttering bats make this cozy knit sweater a darling pick for pumpkin patch adventures, Halloween parties, and all the fun in between. It even comes in a matching mama version for the cutest coordinated look.\n\nFeatures:\n * Sweater Color: Ivory with a black bat and bow pattern \n * Material: 50% Viscose, 30% Polyester, 20% Nylon \n * Fit: True to size \n * Care: Hand wash only, do not iron, tumble dry, bleach or dry clean \n\nEach sweater is packed with love in our hometown warehouse.",
  tags: [],
  msrpDollars: 64,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-12T06:34:32.342Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
